import * as React from "react";
import type { SVGProps } from "react";
const SvgAirplaneRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#airplane-right_svg__a)">
      <path
        fill="currentColor"
        d="M11.65 22A2.65 2.65 0 0 1 9 19.35V15H7.32l-.07.37A2.65 2.65 0 0 1 2 14.85v-5.7a2.65 2.65 0 0 1 5.25-.52l.07.37H9V4.65a2.53 2.53 0 0 1 .75-1.86 2.63 2.63 0 0 1 4.46 1.34L15.19 9H19a3 3 0 1 1 0 6h-3.81l-.95 4.86A2.64 2.64 0 0 1 11.65 22M6.5 13H10a1 1 0 0 1 1 1v5.35a.65.65 0 0 0 1.28.13l1.11-5.67a1 1 0 0 1 1-.81H19a1 1 0 0 0 0-2h-4.63a1 1 0 0 1-1-.81l-1.09-5.68a.65.65 0 0 0-1.07-.32.6.6 0 0 0-.18.45L11 10a1 1 0 0 1-1 1H6.5a1 1 0 0 1-1-.8L5.28 9A.65.65 0 0 0 4 9.15v5.7a.65.65 0 0 0 1.28.15l.24-1.18A1 1 0 0 1 6.5 13"
      />
    </g>
    <defs>
      <clipPath id="airplane-right_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAirplaneRight;
